import { CreateOrderDeliveryDTO } from "../../../../../models/order/order.request";

interface DeliveryTabProps {
    orderDeliveryData: CreateOrderDeliveryDTO;
    onChange: (updatedData: CreateOrderDeliveryDTO) => void;
    deliveryAddressError: string;
    totalAmount: number;
}

const DeliveryTab: React.FC<DeliveryTabProps> = ({ orderDeliveryData, onChange, deliveryAddressError, totalAmount }) => {

    return (
        <div className="modal-form-div-group">
            <div className="modal-group-header">Detalji rezervacije</div>
            <div className="modal-form-div">
                <label className="modal-form-label">Adresa Dostave</label>
                <input className="form-input grey w-input" placeholder="Ulica *" type="text"
                    value={orderDeliveryData.street || ''}
                    onChange={(e) => onChange({ ...orderDeliveryData, street: e.target.value })}
                />
                <div className="div-block-61">
                    <input className="form-input grey w-input" placeholder="Broj *" type="text"
                        value={orderDeliveryData.streetNumber || ''}
                        onChange={(e) => onChange({ ...orderDeliveryData, streetNumber: e.target.value })}
                    />
                    <input className="form-input grey w-input" placeholder="Stan / Sprat (opciono)" type="text"
                        value={orderDeliveryData.apartment || ''}
                        onChange={(e) => onChange({ ...orderDeliveryData, apartment: e.target.value })}
                    />
                </div>
                {deliveryAddressError && <div className="error-text">{deliveryAddressError}</div>}
            </div>
            <div className="modal-form-div">
                <label className="modal-form-label">Napomena</label>
                <textarea placeholder="Unesi napomenu (opciono)" className="form-textarea grey w-input"
                    value={orderDeliveryData.description || ''}
                    onChange={(e) => onChange({ ...orderDeliveryData, description: e.target.value })}    
                />
            </div>
            <div className="modal-form-div">
                <div className="input-div sb final-order-price">
                    <div>Ukupan iznos:</div>
                    <div className="text-block-38">{totalAmount} RSD</div>
                </div>
            </div>
        </div>
    );
};

export default DeliveryTab;